import type { ActionsOfCreators, FeatureHandler } from '../helpers';
import { statusUpdate } from './statusUpdate';

export const outputActions = [statusUpdate];

export type OutputActions = ActionsOfCreators<typeof outputActions>;

export type Handler<T extends OutputActions> = FeatureHandler<T, OutputActions>;
